import DownloadTemplateButton from "./DownloadTemplateButton";

export default DownloadTemplateButton;